module.exports = __webpack_public_path__ + "static/img/轮播_3.6bca8a28.jpg";